/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { accountSchema } from './account-schema';
import { calendarSchema } from './calendar-schema';
import { contactsOpportunitySchema } from './contacts-opportunity-schema';
import { userSchema } from './user-schema';

export const contactSchema: z.AnyZodObject = z.object({
  accounts: z.array(z.lazy(() => accountSchema)).nullish(),
  active: z.boolean(),
  address: z.string().nullish(),
  availabilityNotificationOptOut: z.boolean().nullish(),
  benchNotificationOptOut: z.boolean().nullish(),
  calendar: z.lazy(() => calendarSchema).nullish(),
  canViewPricing: z.boolean(),
  city: z.string().nullish(),
  contactsOpportunities: 
    z.array(z.lazy(() => contactsOpportunitySchema))
  .nullish(),
  country: z.string().nullish(),
  createdAt: z.string().datetime().nullish(),
  email: z.string().nullish(),
  firstName: z.string().nullish(),
  hubspotIntake: z.boolean(),
  id: z.string().uuid(),
  intakeJobRole: z.string().nullish(),
  integrationId: z.string().nullish(),
  jobRole: z.string().nullish(),
  lastName: z.string().nullish(),
  lastOutreachAt: z.string().date().nullish(),
  linkedinUrl: z.string().nullish(),
  mobileNumber: z.string().nullish(),
  phoneNumber: z.string().nullish(),
  salesforceId: z.string().nullish(),
  spvCount: z.number().int().nullish(),
  spvCountCycleDts: z.string().datetime().nullish(),
  state: z.string().nullish(),
  title: z.string().nullish(),
  updatedAt: z.string().datetime().nullish(),
  user: z.lazy(() => userSchema).nullish(),
  welcomeEmailLastSentAt: z.string().datetime().nullish(),
  welcomeEmailLastSentBy: z.string().uuid().nullish(),
  welcomeEmailLastSentByUser: z.lazy(() => userSchema).nullish(),
  zip: z.string().nullish(),
});

export type Contact = z.infer<typeof contactSchema>;
